/** @jsxImportSource @emotion/react */
import { PlainDownArrow, PlainRightArrow } from '../Icons';
import useStyles from './styles';

const LoadMoreResultsButton = ({ onClick, isMapPage, isMobile = false }) => {
  const styles = useStyles();
  return (
    <div
      css={styles.LoadMoreResultsBtnCont(isMapPage)}
      onClick={onClick}
      role="none"
    >
      <button css={styles.LoadMoreResultsBtn}>
        Load More Results{' '}
        {isMobile ? (
          <PlainRightArrow css={styles.PlainDownArrowSVG} />
        ) : (
          <PlainDownArrow css={styles.PlainDownArrowSVG} />
        )}
      </button>
    </div>
  );
};

export default LoadMoreResultsButton;
